// src/pages/VenueDirectoryPage.js
import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { Link } from 'react-router-dom';
import './VenueDirectoryPage.css';

const GET_ALL_VENUES = gql`
  query Query {
  getAllVenues {
    id
    name
    slug
    
  }
}
`;

const VenueDirectoryPage = () => {
  const { loading, error, data } = useQuery(GET_ALL_VENUES);

  if (loading) return <p>Loading venues...</p>;
  if (error) return <p>Error loading venues: {error.message}</p>;

  return (
    <div className="venue-directory">
      <h1>Explore Venues on Gigabout</h1>
      <div className="venue-grid">
        {data.getAllVenues.map((venue) => (
          <Link
            to={`/venuepage/${venue.slug || venue.id}`}
            className="venue-card"
            key={venue.id}
          >
            { /*<img
              src={venue.profileImage || '/default-venue.jpg'}
              alt={venue.name}
              className="venue-image"
            /> */}
            <div className="venue-info">
              <h3>{venue.name}</h3>
              <p>{venue.city}, {venue.state}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default VenueDirectoryPage;
